<template>
  <div class="hab-modal">
    <div v-show="!is_show_cancel_modal_info && !is_show_modal_not_able_cancel" class="hab-modal__box">
      <div class="hab-modal__title">{{ $t('book.cancel_title') }}</div>
      <div class="hab-modal__content">
        <p>{{ $t('book.cancel_note') }}</p>
        <p v-if="error" style="color: red">{{ error }}</p>
        <div
            class="cancel__item"
            v-for="(item, key) in cancellationReasonList"
            :key="key"
        >
          <input
            v-model="cancellation_reason"
            name="cancellation_reason"
            :id="`cancel${key}`"
            type="radio"
            :value="item.id"
          >
          <label :for="`cancel${key}`">{{ item.value }}</label>
        </div>
        <div v-show="cancellation_reason === 7" class="hab-textarea">
          <textarea
            v-model="cancellation_reason_other"
            rows="3"
            :placeholder="$t('book.cancellation_reason_other')"
          />
          <p v-if="error_reason_other" style="color: red">{{ error_reason_other }}</p>
        </div>
      </div>
      <div class="hab-modal__footer">
        <div class="hab-modal__footer__item">
          <span @click="requestCancelInfo">{{ $t('book.cancel_submit') }}</span>
        </div>
        <div class="hab-modal__footer__item">
          <span @click="$emit('close')">{{ $t('book.back') }}</span>
        </div>
      </div>
    </div>
    <CancelModalInfo
      v-show="is_show_cancel_modal_info"
      :cancel-fee="cancel_fee_real"
      :final-total="finalTotal"
      @close="cancelAction"
      @submit="handleCancel(4)"
    />
    <ModalInfo
      v-show="is_show_modal_not_able_cancel"
      :title="$t('book.cancel_title')"
      :content="$t('book.ticket_not_able_cancel')"
      @close="cancelAction"
    />
  </div>
</template>

<script>

import {get} from "lodash";
import CancelModalInfo from "../cancel/modal-cancel-info"
import ModalInfo from "../modal-info"

export default {
  components: {
    CancelModalInfo,
    ModalInfo
  },
  props: {
    ticketCode: {
      type: String,
      default: ''
    },
    bookingCode: {
      type: String,
      default: ''
    },
    serviceFee: {
      type: Number,
      default: 0
    },
    totalFare: {
      type: Number,
      default: 0
    }
  },
  emits: ['close', 'set-cancel-loading', 'set-mode'],
  data () {
    return {
      cancellation_reason: 0,
      cancellation_reason_other: '',
      error: '',
      error_reason_other: '',
      cancel_loading: false,
      is_show_cancel_modal_info: false,
      is_show_modal_info: false,
      is_show_modal_not_able_cancel: false,
      cancel_fee_real: 0,
      refund_info: {}
    }
  },
  computed: {
    cancellationReasonList () {
      return this.$t('book.cancels') || []
    },
    cancellationReason () {
      if (this.cancellation_reason === 7) {
        return this.cancellation_reason_other
      }

      return this.cancellationReasonList.find(item => {
        return item.id === this.cancellation_reason
      })?.value || ''
    },
    finalTotal() {
      return this.totalFare + this.serviceFeeFare
    },
    serviceFeeFare() {
      if (this.totalFare === 0 || this.serviceFee === 0) {
        return 0
      }

      return this.totalFare * this.serviceFee / 100
    }
  },
  methods: {
    requestCancelInfo () {
      if (this.cancel_loading) {
        return;
      }

      if (!this.validate()) {
        return
      }

      this.$emit('set-cancel-loading', true)
      this.cancel_loading = true
      const params = {
        code: this.bookingCode
      };
      this.$store.dispatch("cancelInfo", params)
        .then((result) => {
          this.$emit('set-cancel-loading', false)
          this.cancel_loading = false
          const data = get(result, "data.data", false);
          if (!data) {
            this.$emit('close')
            this.$emit('set-mode', {mode: 'error', data: null})
            return
          }
          if (!data.cancelable) {
            this.is_show_modal_not_able_cancel = true

            return
          }

          if (data.total_fare == 0 && data.cancel_fee == 0 && data.refund == 0) {
            return this.handleCancel(3)
          }

          const totalFare = parseInt(data.total_fare)
          const cancelFee = parseInt(data.cancel_fee)

          const cancelFeePercent = cancelFee * 100 / totalFare
          this.refund_info = data
          this.cancel_fee_real = this.finalTotal * cancelFeePercent / 100
          this.is_show_cancel_modal_info = true
        }).catch(() => {
        this.$emit('set-cancel-loading', false)
        this.cancel_loading = false
      });
    },
    handleCancel (status = 3) {
      this.error = ''
      this.error_reason_other = ''
      if (this.cancel_loading) {
        return;
      }

      if (this.cancellation_reason === 0) {
        this.error = this.$t('book.select_reason')
        return
      }

      if (this.cancellation_reason === 7 && this.cancellation_reason_other === '') {
        this.error_reason_other = this.$t('book.enter_reason')
        return
      }

      const dataSubmit = {
        ticket_code: this.ticketCode,
        cancellation_reason: this.cancellationReason,
        status,
        refund_info: this.refund_info
      }

      this.$emit('close')
      this.$emit('set-cancel-loading', true)
      this.cancel_loading = true
      this.$store.dispatch('cancelTicket', dataSubmit).then((result) => {
          this.$emit('set-cancel-loading', false)
          this.cancel_loading = false
          const data = get(result, "data.data", false);
          if (!data) {
            this.$emit('set-mode', {mode: 'error', data: null})
            return
          }

          this.$emit('set-mode', {mode: 'cancel', data: status})
        }).catch(() => {
          this.$emit('set-cancel-loading', false)
          this.cancel_loading = false
          this.$emit('set-mode', {mode: 'error', data: null})
        })
    },
    cancelAction () {
      this.is_show_cancel_modal_info = false
      this.is_show_modal_not_able_cancel = false
      this.$emit('close')
    },
    validate () {
      this.error = ''
      this.error_reason_other = ''

      if (this.cancellation_reason === 0) {
        this.error = this.$t('book.select_reason')
        return false;
      }

      if (this.cancellation_reason === 7 && this.cancellation_reason_other === '') {
        this.error_reason_other = this.$t('book.enter_reason')
        return false;
      }

      return true;
    }
  }
};
</script>
